/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IDataprotectionNotificationDisplayModel {
  dsgvoAccepted?: boolean;
}
export class DataprotectionNotificationDisplayModel extends BaseModel implements IDataprotectionNotificationDisplayModel {
  dsgvoAccepted?: boolean;
}
class BaseDataprotectionNotificationDisplayModelFormGroup extends FormGroup {
  private static _instance: DataprotectionNotificationDisplayModelFormGroup;
  
  public static get Instance(): DataprotectionNotificationDisplayModelFormGroup {
    this._instance = new DataprotectionNotificationDisplayModelFormGroup({
      dsgvoAccepted: new FormControl(null),
    });

    return this._instance;
  }
}


export class DataprotectionNotificationDisplayModelFormGroup extends BaseDataprotectionNotificationDisplayModelFormGroup {
  public get DsgvoAccepted(): FormControl {
    return this.controls["dsgvoAccepted"] as FormControl;
  }
  

}

export module DataprotectionNotificationDisplayModelForm
  {
    export class FormFields
    {
      static _dsgvoAccepted: string = "dsgvoAccepted";
    }
  }

